module.exports = __webpack_public_path__ + "img/m-banner-cookagaw-ru-RU.09eb1fa8.jpg";